import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Magnet } from "lucide-react";

interface BlogCTAProps {
  title?: string;
  description?: string;
  buttonText?: string;
  buttonLink?: string;
}

const BlogCTA = ({
  title = "Pronto para Capturar Mais Leads?",
  description = "Crie seu primeiro formulário inteligente gratuitamente e veja como a IA pode transformar sua estratégia de captura de leads.",
  buttonText = "Criar Meu Primeiro Formulário",
  buttonLink = "/auth?mode=signup",
}: BlogCTAProps) => {
  return (
    <section 
      className="py-16 md:py-20 bg-gradient-to-br from-primary/10 via-background to-accent/10"
      aria-labelledby="cta-title"
    >
      <div className="container mx-auto px-4 text-center">
        <div className="mx-auto max-w-2xl">
          <div className="mb-6 flex justify-center">
            <div 
              className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/20"
              aria-hidden="true"
            >
              <Magnet className="h-8 w-8 text-primary" />
            </div>
          </div>
          <h2 
            id="cta-title"
            className="mb-4 text-2xl font-bold md:text-4xl"
          >
            {title}
          </h2>
          <p className="mb-8 text-lg text-muted-foreground">
            {description}
          </p>
          <Button 
            size="lg" 
            asChild 
            className="gap-2 px-8"
          >
            <Link 
              to={buttonLink}
              aria-label={`${buttonText} - Criar conta gratuita`}
            >
              {buttonText}
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default BlogCTA;
